const getPortfolioImages = (slug, maxCount = 20) => {
  const images = [];
  for (let i = 1; i <= maxCount; i++) {
    const imgPath = `/assets/images/land/${slug}/${i}.jpg`;
    images.push({ image: imgPath });
  }
  return images;
};

const LandDetailPageInfo = [
  {
    slug: "bodrum-land",
    type: "land",
    imageCount: 11,
    title: "Bodrum Land Kumköy",
    secondTitle: "£ 5,990,000",
    description: "BODRUM, KUMKÖY",
    detailTitle: "Land in Bodrum",
    detailDescription:
      "Exceptional Investment Land for Sale in Bodrum – Kumköy",
    mainImage: "/assets/images/land/bodrum-land/1.jpg",
    area: "115,971  m2",
    content: [
      {
        type: "blockquote",
        text: "115,971 m² | Prime Location Next to Regnum Golf Course",
      },
      {
        type: "paragraph",
        text: "Set within the unspoiled natural landscape of Kumköy, Bodrum, this remarkable 115,971 m² land parcel presents a rare opportunity to secure a substantial piece of the Bodrum Peninsula in a location that combines natural beauty, strategic positioning, and long-term investment value.",
      },
      {
        type: "paragraph",
        text: "Positioned among the gently rolling hills and characteristic Mediterranean vegetation of the region, the property offers expansive countryside views, privacy, and a serene atmosphere that captures the essence of Bodrum’s rural charm. At the same time, it remains conveniently connected to the lively coastal lifestyle for which Bodrum is internationally known.",
      },
      {
        type: "paragraph",
        text: "The land is located directly adjacent to the renowned Regnum Golf Course, one of the area’s most prestigious leisure developments. This proximity places the property within an emerging zone of high-end tourism and lifestyle investment, making it particularly attractive for investors seeking opportunities aligned with Bodrum’s continuing growth in luxury tourism and residential development.",
      },
      {
        type: "paragraph",
        text: "With a total surface area of 115,971 square metres, the plot offers exceptional scale and flexibility. Its 2B land designation further enhances its investment appeal, providing significant potential for future value appreciation as the Bodrum Peninsula continues to evolve as one of Türkiye’s most sought-after international destinations.",
      },
      {
        type: "paragraph",
        text: "Importantly, the land already benefits from existing infrastructure connections, including water, electricity, and internet, ensuring practical accessibility and facilitating future planning considerations.",
      },
      {
        type: "paragraph",
        text: "Despite its peaceful natural setting, the property enjoys easy access to Bodrum town centre, the region’s vibrant marina, fine dining venues, boutique hotels, and cultural attractions. The peninsula’s celebrated beaches, turquoise coves, and beach clubs are also within comfortable reach, offering the perfect balance between secluded countryside and coastal luxury.",
      },
      {
        type: "image",
        src: "/assets/images/land/bodrum-land/2.jpg",
        alt: "Altınkum Plot",
      },
      {
        type: "blockquote",
        text: "Key Highlights",
      },
      {
        type: "list",
        items: [
          "Total Land Size: 115,971 m²",
          "Land Designation: 2B",
          "Infrastructure Available: Water, electricity, and internet",
          "Location: Kumköy, Bodrum Peninsula",
          "Adjacent to the prestigious Regnum Golf Course",
          "Expansive panoramic countryside views",
          "Easy access to Bodrum centre, beaches, and marina",
          "Exceptional long-term investment potential",
        ],
      },
      {
        type: "paragraph",
        text: "Large parcels of land of this scale and positioning are increasingly rare on the Bodrum Peninsula. Whether considered as a strategic land holding or a long-term investment within a rapidly developing luxury destination, this property represents a distinctive opportunity to secure a significant presence in one of the Mediterranean’s most desirable regions.",
      },
      {
        type: "blockquote",
        text: "Further details, location information, and viewing arrangements are available upon request.",
      },
    ],
    PortfolioList2: getPortfolioImages("kaltınkum-plot"),
  },
  {
    slug: "altınkum-plot",
    type: "land",
    imageCount: 5,
    title: "Altınkum Plot",
    secondTitle: "£ 990,000",
    description: "ALTINKUM, ÇEŞME",
    detailTitle: "Land in Çeşme",
    detailDescription:
      "Prime Investment Land with Sea Proximity in Altınkum, Çeşme",
    mainImage: "/assets/images/land/altınkum-plot/1.jpg",
    area: "14,474 m2",
    content: [
      {
        type: "blockquote",
        text: "14,474 m² | Road Access | Olive Groves",
      },
      {
        type: "paragraph",
        text: "Located in the highly sought-after Altınkum area of Çeşme, this exceptional 14,474 m² plot offers a rare opportunity to secure a substantial piece of land in one of the Aegean’s most prestigious and fast-developing regions.",
      },
      {
        type: "paragraph",
        text: "The land enjoys direct road access, ensuring easy connectivity and practicality for future development. Naturally enriched with mature olive groves, the property combines authentic Aegean character with long-term investment potential.",
      },
      {
        type: "image",
        src: "/assets/images/land/altınkum-plot/5.jpg",
        alt: "Altınkum Plot",
      },
      {
        type: "paragraph",
        text: "Set on an elevated landscape, the plot benefits from open surroundings and a peaceful rural atmosphere, while still being just a short drive from Altınkum Beach, Çeşme Marina, luxury resorts, restaurants, and beach clubs. The area is well known for its crystal-clear waters, strong tourism demand, and increasing value year on year.",
      },
      {
        type: "blockquote",
        text: "With its generous size, strategic location, and natural features, this land is ideal for:",
      },
      {
        type: "list",
        items: [
          "Boutique residential or villa projects",
          "Eco-focused or agricultural investments",
          "Long-term land banking in a prime Çeşme location",
        ],
      },
      {
        type: "image",
        src: "/assets/images/land/altınkum-plot/3.jpg",
        alt: "Altınkum Plot",
      },
      {
        type: "paragraph",
        text: "A rare opportunity to invest in large-scale land in Altınkum, where nature, accessibility, and future value meet.",
      },
      {
        type: "blockquote",
        text: "Details available upon request. Private viewings recommended.",
      },
    ],
    PortfolioList2: getPortfolioImages("kaltınkum-plot"),
  },
  {
    slug: "kalkan-arsa",
    type: "land",
    imageCount: 9,
    title: "Kalkan Plot",
    secondTitle: "£ 755,000",
    description: "KALKAN, ANTALYA",
    detailTitle: "Land near Kalkan ready for Investment.",
    detailDescription:
      "Panoramic 9,000 m² Sea-View Plot Near Kalkan — Prime Development Opportunity",
    mainImage: "/assets/images/land/kalkan-arsa/2.jpg",
    area: "9000 m2",
    content: [
      {
        type: "list",
        items: [
          "Location: Hillside near Kalkan, Antalya",
          "Land Size: ~9,000 m² (single title)",
          "Aspect: Broad Mediterranean sea and valley panorama",
          "Use: Private estate, multi-villa concept, or eco-retreat (all subject to permits)",
        ],
      },
      {
        type: "blockquote",
        text: "Overview",
      },
      {
        type: "paragraph",
        text: "This substantial hillside parcel sits just outside Kalkan, capturing sweeping, unobstructed views across verdant valleys to the shimmering Mediterranean. With an impressive ~9,000 m² footprint, varied natural contours, and a tranquil rural setting, the property offers the rare combination of privacy, scale, and picture-perfect vistas—an ideal canvas for a signature residence or boutique hospitality project.",
      },
      {
        type: "image",
        src: "/assets/images/land/kalkan-arsa/1.jpg",
        alt: "Kalkan Land Plot",
      },
      {
        type: "blockquote",
        text: "What makes it special",
      },
      {
        type: "list",
        items: [
          "Commanding elevation: Long, uninterrupted sightlines to the sea, surrounding hills, and dramatic headlands.",
          "Expansive breadth: Ample room to separate living, guest, and service areas; scope for gardens, orchards, and view decks.",
          "Quiet yet connected: Peaceful countryside atmosphere a short drive from Kalkan’s marina, restaurants, supermarkets, and beaches.",
          "Scarcity value: Large sea-view plots near Kalkan are increasingly limited—strong long-term hold and build potential.",
        ],
      },
      {
        type: "blockquote",
        text: "Terrain & Site Characteristics",
      },
      {
        type: "paragraph",
        text: "The land features a mix of gentle and steeper slopes—excellent for terraced architecture that steps with the landscape, ensuring every structure can enjoy the vista. Natural stone outcrops and mature vegetation provide character and wind protection while helping define outdoor rooms, trails, and seating areas. The broad frontage invites a dramatic arrival sequence and discrete service access.",
      },
      {
        type: "blockquote",
        text: "Utilities, Access & Planning",
      },
      {
        type: "list",
        items: [
          "Road access: Existing local road approaches the area; final meters to be confirmed on viewing.",
          "Services: Connection points for water and electricity are in the vicinity; exact availability and capacity to be verified with the relevant authorities.",
          "Zoning/build coefficients: Buyers should conduct due diligence with the local municipality (İmar) regarding buildability, footprint, height, and potential subdivision. We can introduce experienced local architects, planners, and lawyers to support feasibility, topographic survey, and permitting.",
          "Environmental considerations: The topography lends itself to low-impact, sustainable design—rainwater harvesting, solar orientation, and native planting.",
        ],
      },
      {
        type: "image",
        src: "/assets/images/land/kalkan-arsa/6.jpg",
        alt: "Kalkan Land Plot",
      },
      {
        type: "blockquote",
        text: "Development",
      },
      {
        type: "list",
        items: [
          "Private Estate with Guest Annexes Main villa with infinity pool, separate guest suites, staff accommodation, orchard, and walking paths.",
          "Two–Four Luxury Villas Each with private pool and parking, designed as tiered pavilions to protect views and privacy—strong rental credentials in the Kalkan market.",
          "Eco-Retreat / Wellness Concept Cluster of cabins or suites integrated into the hillside with shared wellness deck, yoga pavilion, and farm-to-table gardens. (All subject to permits, engineering, and compliance with local planning rules.)",
        ],
      },
      {
        type: "blockquote",
        text: "Lifestyle & Surroundings",
      },
      {
        type: "paragraph",
        text: "Kalkan is renowned for refined dining, white-washed alleys, beach clubs, and a vibrant yachting scene. From this hillside setting you’ll enjoy serene privacy by day and the convenience of town and coast a short drive away. Nearby outdoor pursuits include coastal hikes, boat excursions to islands and bays, and historic sites along the Lycian Way.",
      },
      {
        type: "blockquote",
        text: "Investment Notes",
      },
      {
        type: "list",
        items: [
          "Demand drivers: Limited supply of large sea-view land close to Kalkan; strong seasonal rental market for view-oriented villas.",
          "Value creation: Master-planning, thoughtful architecture, and phased development can unlock significant upside.",
          "Exit flexibility: Hold as land, build to own, or complete a villa cluster for sale to end-users/investors.",
        ],
      },
      {
        type: "blockquote",
        text: "Next Steps",
      },
      {
        type: "paragraph",
        text: "Full coordinates, drone footage, and a preliminary feasibility brief are available upon request. We would be pleased to arrange a site visit and introduce trusted local professionals for surveys, design concepts, and planning checks.",
      },
    ],
    PortfolioList2: getPortfolioImages("kalkan-arsa"),
  },
  {
    slug: "faralya-arsa",
    type: "land",
    imageCount: 6,
    title: "Faralya Plot",
    secondTitle: "£ 270,000",
    description: "FARALYA, FETHİYE",
    detailTitle: "Panoramic Land in Farlaya",
    detailDescription:
      "Panoramic Sea-View Plot in Faralya — 562 m² | Build up to 250 m² | Option to Combine with Neighboring Parcel",
    mainImage: "/assets/images/land/faralya-arsa/5.jpg",
    area: "562 m2",
    content: [
      {
        type: "paragraph",
        text: "Set on an elevated ridge in Faralya, this 562 m² freehold plot delivers uninterrupted Mediterranean vistas—sea views as far as the eye can see. With a build right of up to 250 m² (subject to municipal approvals), it’s a rare chance to create a statement villa in one of the most sought-after coastal hamlets on the Fethiye–Faralya–Kabak line. An adjacent plot is also for sale, allowing buyers to merge both parcels for a landmark private estate or boutique development.",
      },
      {
        type: "blockquote",
        text: "Property Highlights",
      },
      {
        type: "list",
        items: [
          "Land size: 562 m² (freehold)",
          "Buildability: Up to 250 m² closed area (buyer to confirm with local municipality/zoning)",
          "Topography: Gentle natural slope—ideal for split-level architecture and infinity pool design",
          "Views: Elevated, unobstructed Mediterranean panorama; sunset-facing orientation",
          "Surroundings: Low-density area with mature greenery and quality neighboring homes",
          "Scalability: Neighboring plot available—combine for a signature compound or twin-villa project",
        ],
      },
      {
        type: "image",
        src: "/assets/images/land/faralya-arsa/1.jpg",
        alt: "Kalkan Land Plot",
      },
      {
        type: "blockquote",
        text: "Location & Lifestyle",
      },
      {
        type: "paragraph",
        text: "Faralya balances privacy with proximity. Nestled above the coastline, you are moments from hidden coves, hiking paths, and boutique hotels, yet close enough to reach Fethiye’s full services when needed. The area is prized for its tranquil atmosphere, dramatic sea cliffs, and crystal-clear waters, making it a preferred choice for luxury villa owners and high-end holiday rentals.",
      },
      {
        type: "blockquote",
        text: "Approx. driving times (subject to route/traffic):",
      },
      {
        type: "list",
        items: [
          "Kabak Beach: 10–15 mins",
          "Ölüdeniz Lagoon: 25–30 mins",
          "Fethiye Centre: 40–50 mins",
          "Dalaman Airport: ~1 hr 10–20 mins",
        ],
      },
      {
        type: "blockquote",
        text: "Design Potential",
      },
      {
        type: "paragraph",
        text: "The plot’s orientation and slope support a 4–5 bedroom villa with expansive outdoor living potential:",
      },
      {
        type: "list",
        items: [
          "Infinity pool + sun decks aligned to the horizon line",
          "Floor-to-ceiling glazing to capture the sea and sunset",
          "Terraced gardens with native planting, pergolas, and an outdoor kitchen",
          "Guest suite or garden annex for privacy",
          "Private driveway/covered parking",
          "(Concept drawings and introductions to local architects, engineers, and project managers can be arranged.)",
        ],
      },
      {
        type: "image",
        src: "/assets/images/land/faralya-arsa/6.jpg",
        alt: "Kalkan Land Plot",
      },
      {
        type: "blockquote",
        text: "Development & Technical Notes",
      },
      {
        type: "list",
        items: [
          "Planning: Buyer to verify zoning, permitted footprint, height limits, and setbacks with the municipality and an architect.",
          "Utilities: Power and water supply available in the wider area; on-site connection and infrastructure to be completed by the buyer (standard for the location).",
          "Access: Established vehicular access; road improvements and retaining works can be integrated into the build plan.",
        ],
      },
      {
        type: "blockquote",
        text: "Investment Rationale",
      },
      {
        type: "list",
        items: [
          "View premium: True horizon views command higher resale and rental rates.",
          "Build readiness: Clear development path with meaningful 250 m² closed area potential.",
          "Flexibility: Option to acquire the neighboring plot—scale to a double frontage villa, multi-unit family compound, or two luxury villas.",
          "Demand: Persistent interest in Faralya for luxury holiday lettings and private second homes supports strong yield and long-term value.",
        ],
      },
      {
        type: "blockquote",
        text: "Option to Merge",
      },
      {
        type: "paragraph",
        text: "The adjoining parcel is also on the market. Combining both creates a larger holding suitable for:",
      },
      {
        type: "list",
        items: [
          "Grand single residence with extensive gardens and wellness wing (spa/sauna/gym)",
          "Twin villas for multi-generational living or premium rental strategy",
          "Boutique two- or three-villa project (subject to planning)",
        ],
      },
    ],
    PortfolioList2: getPortfolioImages("faralya-arsa"),
  },
  {
    slug: "kas-bezirgan",
    type: "land",
    imageCount: 7,
    title: "Land in Kaş, Bezirgan",
    secondTitle: "£ 160,000",
    description: "KAŞ, ANTALYA",
    detailTitle: "Bezirgan Plateau Land with Stone House",
    detailDescription:
      "Bezirgan, Kaş — 1,098 m² Plot with Semi-Built Stone House ",
    mainImage: "/assets/images/land/kas-bezirgan/3.jpg",
    area: "1098 m2",
    content: [
      {
        type: "paragraph",
        text: "Discover a rare countryside opportunity in the tranquil village of Bezirgan, set on a lush green plateau in the Taurus Mountains, just 14 km from Kalkan. This generous 1,098 m² freehold plot comes with a semi-built natural-stone house—the perfect head start for creating your private mountain retreat with authentic village character.",
      },
      {
        type: "blockquote",
        text: "Property Highlights",
      },
      {
        type: "list",
        items: [
          "Land size: 1,098 m²",
          "Structure: Semi-built stone house shell with traditional architecture",
          "Setting: Elevated plateau ringed by rolling hills and pine-covered mountains",
          "Location: Bezirgan village, 14 km to Kalkan’s restaurants, marinas, and beaches",
          "Ambience: Quiet, green, and breezy—cooler summer temperatures than the coast",
          "Access: Established village location with year-round accessibility",
          "Potential: Countryside villa, wellness hideaway, or a boutique farmstead (subject to local permissions)",
        ],
      },
      {
        type: "image",
        src: "/assets/images/land/kas-bezirgan/5.jpg",
        alt: "Kas Bezirgan",
      },
      {
        type: "blockquote",
        text: "Why We Love It",
      },
      {
        type: "paragraph",
        text: "The property marries authentic Anatolian stonework with wide-open green vistas. Morning light washes over the plateau; evenings bring dramatic mountain silhouettes and starry skies. You’re close enough to enjoy Kalkan’s cosmopolitan lifestyle yet tucked away in a village known for its peace, fertile fields, and timeless rhythm.",
      },
      {
        type: "blockquote",
        text: "Development Notes",
      },
      {
        type: "paragraph",
        text: "The existing stone structure provides a valuable foundation—saving time and cost versus a full new build. Buyers can complete and customize the layout, finishes, terraces, and landscaping to their taste. All further works and connections should be carried out in line with local planning rules and utility approvals.",
      },
      {
        type: "image",
        src: "/assets/images/land/kas-bezirgan/6.jpg",
        alt: "Kas Bezirgan",
      },
      {
        type: "blockquote",
        text: "Location & Lifestyle",
      },
      {
        type: "list",
        items: [
          "Bezirgan Village: Traditional, green, and community-oriented",
          "Kalkan: 14 km — fine dining, marinas, boutiques, and coastal amenities",
          "Taurus Mountains: Endless hiking, cycling, and nature exploration",
        ],
      },
      {
        type: "paragraph",
        text: "If you’re seeking space, authenticity, and a head start on construction in one of Kaş district’s most picturesque villages, this plot in Bezirgan is a standout.",
      },
      {
        type: "blockquote",
        text: "Viewings by appointment only. Contact us to receive the full information pack and to discuss development options and permissions for your intended use.",
      },
    ],
    PortfolioList2: getPortfolioImages("kas-bezirgan"),
  },
  {
    slug: "kas-bezirgan2",
    type: "land",
    imageCount: 9,
    title: "Land in Kaş, Bezirgan Plateau",
    secondTitle: "£ 70,000",
    description: "KAŞ, ANTALYA",
    detailTitle: "Bezirgan Plot",
    detailDescription: "Bezirgan Plateau, Kaş — 1,720 m² Land For Sale",
    mainImage: "/assets/images/land/kas-bezirgan2/1.jpg",
    area: "1720 m2",
    content: [
      {
        type: "paragraph",
        text: "A rare, wide-fronted 1,720 m² parcel on the serene Bezirgan Plateau, set among fertile fields and sweeping Taurus Mountain views—just ~14 km (15–20 min) from Kalkan.",
      },
      {
        type: "blockquote",
        text: "Highlights",
      },
      {
        type: "list",
        items: [
          "Size: 1,720 m² (freehold)",
          "Setting: Flat, usable land with long sightlines across the plateau",
          "Views: Open countryside and dramatic mountain backdrop",
          "Climate: Cooler summers than the coast; clean air and starry skies",
          "Access: Year-round village road access; neighboring homes and bungalows nearby",
          "Utilities: Mains connections available in the area (buyer to confirm hook-ups)",
          "Potential Uses: Country villa with generous garden/orchard, hobby farm, or low-impact tourism concept such as bungalows/glamping—subject to local planning permissions",
        ],
      },
      {
        type: "image",
        src: "/assets/images/land/kas-bezirgan2/7.jpg",
        alt: "Kas Bezirgan No 2",
      },
      {
        type: "blockquote",
        text: "Why This Plot",
      },
      {
        type: "paragraph",
        text: "Bezirgan offers the space and tranquility missing from the coast while keeping you close to Kalkan’s beaches, marina, dining, and services. The land’s level topography minimizes groundwork costs and makes design and landscaping straightforward.",
      },
      {
        type: "image",
        src: "/assets/images/land/kas-bezirgan2/3.jpg",
        alt: "Kas Bezirgan No 2",
      },
      {
        type: "blockquote",
        text: "Lifestyle & Location",
      },
      {
        type: "list",
        items: [
          "Traditional, green village community on a lush plateau",
          "Walking and cycling straight from your gate",
          "Easy reach of Kaş district attractions, Lycian Way trails, and seaside days in Kalkan",
        ],
      },
    ],
    PortfolioList2: getPortfolioImages("kas-bezirgan2"),
  },
  {
    slug: "uzumlu-arsa",
    type: "land",
    imageCount: 3,
    title: "Üzümlü Plot",
    secondTitle: "£ 140,000",
    description: "ÜZÜMLÜ, FETHİYE",
    detailTitle: "Land with Valley and Village views.",
    detailDescription:
      "Plot for Sale in Bucak, Üzümlü — 752 m² with Expansive Village and Valley Views",
    mainImage: "/assets/images/land/uzumlu-arsa/3.jpg",
    area: "752 m2",
    content: [
      {
        type: "paragraph",
        text: "Discover the serenity of rural living in this 752 m² plot located in the Bucak neighbourhood of Üzümlü Village, one of the most sought-after countryside areas near Fethiye. Surrounded by lush greenery and panoramic mountain landscapes, this plot offers a stunning view stretching across Üzümlü Village and the plains below — an ideal setting for building a peaceful retreat or a stylish countryside home.",
      },
      {
        type: "paragraph",
        text: "Set amidst olive groves and pine-covered hills, the location combines privacy with convenience. The village centre, known for its weekly market, vineyards, and artisan community, is just a few minutes away, while Fethiye town centre is reachable within 25 minutes. The elevated position ensures both uninterrupted vistas and a refreshing microclimate, ideal for those who value open skies and nature’s quiet rhythms.",
      },
      {
        type: "image",
        src: "/assets/images/land/uzumlu-arsa/1.jpg",
        alt: "Üzümlü Plot",
      },
      {
        type: "paragraph",
        text: "The plot provides ample space for a private villa, guesthouse, or eco-home project, with easy access to infrastructure and road connections. Its location on the Bucak side of Üzümlü offers both sun exposure and scenic beauty, making it a prime choice for buyers looking to combine investment potential with lifestyle value.",
      },
      {
        type: "paragraph",
        text: "Whether you envision a modern countryside residence, a tranquil retreat, or a holiday home in nature, this land captures the essence of the Fethiye highlands — peaceful, green, and inspiring.",
      },

      {
        type: "image",
        src: "/assets/images/land/uzumlu-arsa/2.jpg",
        alt: "Üzümlü Plot",
      },
    ],
    PortfolioList2: getPortfolioImages("uzumlu-arsa"),
  },
  {
    slug: "karagozler-plot",
    type: "land",
    imageCount: 8,
    title: "Karagözler Plot",
    secondTitle: "£ 560,000",
    description: "KARAGÖZLER, FETHİYE",
    detailTitle: "PRIME LOCATION FOR DEVELOPMENT IN KARAGOZLER",
    detailDescription:
      "Prime Development Plot with Sea Views in Karagözler, Fethiye",
    mainImage: "/assets/images/land/karagozler-plot/3.jpg",
    area: "262 m2",
    content: [
      {
        type: "paragraph",
        text: "This 263 m² plot in Karagözler represents a rare investment opportunity in one of Fethiye’s most sought-after central neighbourhoods. The existing house is 2 storeys with 3 rooms and is being sold as a structure to be renovated or to be demolished for a development opportunity, allowing the new owner to design and build modern flats that can fully maximise the elevated position and beautiful sea views.",
      },
      {
        type: "paragraph",
        text: "Set on a quiet residential street just above the waterfront, the plot enjoys outlooks toward Fethiye Bay and is surrounded by quality homes and boutique residences. With its prime location in the heart of Fethiye, this is an excellent option for developers or investors looking to create high-demand apartments for resale or rental in a prestigious address. ",
      },
      {
        type: "image",
        src: "/assets/images/land/karagozler-plot/6.jpg",
        alt: "Karagözler Plot",
      },
      {
        type: "blockquote",
        text: "Key Features",
      },
      {
        type: "list",
        items: [
          "263 m² plot in Karagözler, central Fethiye",
          "Existing structure to be demolished or renovated",
          "Potential to build new flats with sea views (subject to planning)",
          "Prime, highly sought-after neighbourhood close to the town centre and marina",
          "Elevated position with views over the sea and surrounding greenery",
          "Ideal investment opportunity for developers or those seeking a flagship project in Fethiye’s best location",
        ],
      },
      {
        type: "paragraph",
        text: "Set just above the seafront, the land benefits from an elevated position with attractive views toward Fethiye Bay and the marina. With the right architectural design, new flats here can enjoy open sea views and natural light, making them highly desirable for both year-round living and premium holiday rentals. Karagözler is known for its quiet, leafy streets, proximity to the shoreline and yacht marina, and its easy access on foot to Fethiye’s town centre, restaurants, cafés, and amenities.",
      },
      {
        type: "image",
        src: "/assets/images/land/karagozler-plot/7.jpg",
        alt: "Karagözler Plot",
      },
      {
        type: "paragraph",
        text: "This is an ideal opportunity for investors and developers looking to build modern apartments or an exclusive residence in a location where new stock is extremely limited. The area already attracts an international clientele, professionals, and discerning buyers seeking central homes with sea views—ensuring strong resale and rental potential for any well-planned project (subject to local planning permissions and regulations).",
      },
    ],
    PortfolioList2: getPortfolioImages("karagozler-plot"),
  },
  {
    slug: "kumluova-plot",
    type: "land",
    imageCount: 10,
    title: "Kumluova Plot",
    secondTitle: "£ 110,000",
    description: "KUMLUOVA, SEYDİKEMER",
    detailTitle: "Panoramic Land in Kumluova",
    detailDescription:
      "700 m² Sea-View Plot for Sale in Kumluova, Seydikemer – Elevated Position in a Developing Area",
    mainImage: "/assets/images/land/kumluova-plot/4.jpg",
    area: "262 m2",
    content: [
      {
        type: "paragraph",
        text: "An excellent opportunity to acquire a 700 m² plot in Kumluova, Seydikemer, set on an elevated hillside with open sea and landscape views. Located in a rapidly developing residential area, this plot offers strong potential for both private use and future investment.",
      },
      {
        type: "paragraph",
        text: "The land enjoys a commanding position on the hill, providing privacy, fresh air, and panoramic surroundings. New villas and quality developments in the immediate vicinity highlight the area’s growing appeal, making this an ideal time to invest.",
      },
      {
        type: "image",
        src: "/assets/images/land/kumluova-plot/5.jpg",
        alt: "Kumluova Plot",
      },
      {
        type: "blockquote",
        text: "Key Features:",
      },
      {
        type: "list",
        items: [
          "700 m² land plot",
          "Elevated hillside location",
          "Sea and open countryside views",
          "Developing neighborhood with modern villas nearby",
          "Ideal for a private villa or investment project",
          "Peaceful setting with natural surroundings",
          "Easy access to Kumluova village and Seydikemer center",
        ],
      },
      {
        type: "image",
        src: "/assets/images/land/kumluova-plot/2.jpg",
        alt: "Kumluova Plot",
      },
      {
        type: "paragraph",
        text: "Whether you are planning to build a custom-designed villa or secure land in a region with rising demand, this plot offers an attractive balance of views, location, and future value.",
      },
      {
        type: "paragraph",
        text: "For further details or to arrange a site visit, please contact us.",
      },
    ],
    PortfolioList2: getPortfolioImages("kumluova-plot"),
  },
];

export default LandDetailPageInfo;
